import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 翻訳リソースのインポート
import translationEN from './en/translation.json';
import translationJA from './ja/translation.json';
import translationMS from './ms/translation.json';

// 利用可能な言語リソース
const resources = {
  en: {
    translation: translationEN
  },
  ja: {
    translation: translationJA
  },
  ms: {
    translation: translationMS
  }
};

// i18next の設定
const configureI18n = () => {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: 'en',
      debug: process.env.NODE_ENV === 'development',
      interpolation: {
        escapeValue: false
      },
      detection: {
        order: ['navigator', 'localStorage'],
        caches: []
      }
    });

  return i18n;
};

export default configureI18n;